































































import { Component, Mixins, Prop } from 'vue-property-decorator'
import { ExStore } from 'vuex'
import {
  BleDeviceTypes,
  EcgTermHR,
  DEFAULT_ECG_TERM_HR,
  DEFAULT_CONSTANT_ECG
} from '@/constants/ble'
import Form from '@/mixins/form'
import BleProvider from '@/ble'
import { BLEDevice } from '@/ble/types'

@Component({
  components: {
    RadioInput: () => import('@/components/common/inputs/RadioInput2.vue')
  }
})
export default class EcgSettingModal extends Mixins(Form) {
  @Prop({ type: Object, required: true }) device!: BLEDevice
  $store!: ExStore
  message = ''
  pending = false
  inputConstantECG = this.bleConfigSetting
    ? this.bleConfigSetting.constantECG
    : DEFAULT_CONSTANT_ECG
  inputTermHR: EcgTermHR = this.bleConfigSetting
    ? (this.bleConfigSetting.termHR as EcgTermHR)
    : DEFAULT_ECG_TERM_HR

  get bleConfigSetting() {
    const config = this.$store.getters['appSettings/bleConfig'](
      this.device.address
    )

    return config ? config.config : null
  }

  get constantECGOptions() {
    return [
      { label: '心電モード', value: true },
      { label: '心拍モード', value: false }
    ]
  }

  get termHROptions() {
    return [
      EcgTermHR.TERM_5,
      EcgTermHR.TERM_10,
      EcgTermHR.TERM_30,
      EcgTermHR.TERM_60
    ]
  }

  async handleClickSave() {
    if (this.pending) {
      return
    }

    try {
      this.message = ''

      this.pending = true

      const device = BleProvider.getDeviceByDeviceType(
        BleDeviceTypes.ECG_SERVICE
      )

      if (!device) {
        throw new Error('Device not found!')
      }

      const config = {
        constantECG: this.inputConstantECG,
        termHR: this.inputTermHR
      }

      try {
        await BleProvider.changeNC1BLEConfig(device.address, config)
      } catch (error) {
        console.error('BleProvider.changeNC1BLEConfig: ', error)
      }

      await this.$store.dispatch('appSettings/updateBleConfig', {
        [device.address]: {
          deviceType: device.deviceType,
          deviceName: device.deviceName,
          address: device.address,
          config
        }
      })

      this.$emit('close')
    } catch (error) {
      console.error(error)
      this.message = '更新に失敗しました。もう一度お試しください。'
    } finally {
      this.pending = false
    }
  }

  handleClickCancel() {
    this.$emit('close')
  }

  handleClickClose() {
    this.$emit('close')
  }
}
